<template>
    <button
        type="button"
        class="border border-blue-500 hover:border-blue-600 text-blue-600 hover:text-blue-700 bg-white hover:bg-blue-100 uppercase font-semibold tracking-wider leading-normal"
        :class="[size_classes, { 'cursor-pointer': !disabled, 'cursor-not-allowed opacity-50': disabled }]"
        :disabled="disabled"
        @click.stop="handleClick"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        size: { default: 'normal'},
        disabled: { default: false },
    },

    computed: {
        size_classes() {
            return {
                'normal': 'text-xs px-6 py-3',
                'small': 'text-2xs px-5 py-2',
                'x-small': 'text-2xs px-4 py-1',
            }[ this.size ];
        },
    },

    methods: {
        handleClick(event) {
            this.$emit('click', event);
        },
    },
}
</script>
